"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileProcessingServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
class FileProcessingService extends client_1.RWSService {
    async uploadFile(file) {
        try {
            // file.path contains base64 data without mime prefix
            // file.mimeType contains the mime type
            // Decode base64 to string
            const decodedContent = atob(file.path);
            // Return the decoded content as string
            return decodedContent;
        }
        catch (error) {
            console.error('Error decoding file content:', error);
            throw new Error('Failed to decode file content');
        }
    }
    async parseCSV(content) {
        var _a, _b, _c;
        const lines = content.split('\n').filter(line => line.trim());
        if (lines.length < 2) {
            throw new Error('CSV file must contain at least a header row and one data row');
        }
        const headers = this.parseCSVLine(lines[0]);
        const data = [];
        // Validate required columns
        const requiredColumns = ['input', 'output'];
        const missingColumns = requiredColumns.filter(col => !headers.some(header => header.toLowerCase() === col.toLowerCase()));
        if (missingColumns.length > 0) {
            throw new Error(`Missing required columns: ${missingColumns.join(', ')}`);
        }
        // Find column indices
        const inputIndex = headers.findIndex(h => h.toLowerCase() === 'input');
        const outputIndex = headers.findIndex(h => h.toLowerCase() === 'output');
        const categoryIndex = headers.findIndex(h => h.toLowerCase() === 'category');
        // Process data rows
        for (let i = 1; i < lines.length; i++) {
            const row = this.parseCSVLine(lines[i]);
            if (row.length < Math.max(inputIndex, outputIndex) + 1) {
                continue;
            }
            const trainingItem = {
                id: `item_${i}`,
                input: ((_a = row[inputIndex]) === null || _a === void 0 ? void 0 : _a.trim()) || '',
                output: ((_b = row[outputIndex]) === null || _b === void 0 ? void 0 : _b.trim()) || '',
                category: categoryIndex >= 0 ? (_c = row[categoryIndex]) === null || _c === void 0 ? void 0 : _c.trim() : undefined,
                metadata: {}
            };
            // Add additional metadata from other columns
            headers.forEach((header, index) => {
                if (index !== inputIndex && index !== outputIndex && index !== categoryIndex) {
                    trainingItem.metadata[header] = row[index];
                }
            });
            data.push(trainingItem);
        }
        return data;
    }
    exportToCSV(data) {
        if (data.length === 0) {
            return 'input,output,category\n';
        }
        const headers = ['input', 'output', 'category'];
        const csvRows = [headers.join(',')];
        data.forEach(item => {
            const row = [
                this.escapeCSVField(item.input),
                this.escapeCSVField(item.output),
                this.escapeCSVField(item.category || '')
            ];
            csvRows.push(row.join(','));
        });
        return csvRows.join('\n');
    }
    parseCSVLine(line) {
        const result = [];
        let currentField = '';
        let inQuotes = false;
        for (let i = 0; i < line.length; i++) {
            const char = line[i];
            if (char === '"') {
                if (inQuotes && line[i + 1] === '"') {
                    currentField += '"';
                    i++; // Skip next quote
                }
                else {
                    inQuotes = !inQuotes;
                }
            }
            else if (char === ',' && !inQuotes) {
                result.push(currentField.trim());
                currentField = '';
            }
            else {
                currentField += char;
            }
        }
        result.push(currentField.trim());
        return result;
    }
    escapeCSVField(field) {
        if (!field)
            return '';
        // If field contains comma, quote, or newline, wrap in quotes
        if (field.includes(',') || field.includes('"') || field.includes('\n')) {
            // Escape existing quotes by doubling them
            const escaped = field.replace(/"/g, '""');
            return `"${escaped}"`;
        }
        return field;
    }
}
exports.FileProcessingServiceInstance = FileProcessingService;
exports.default = FileProcessingService.getSingleton();
